import React from "react";
import { motion } from "framer-motion";
import { fadeUp, Section } from "./shared";

const TESTIMONIALS = [
  { q: "Applied Monday, funded by Wednesday. No fuss.", n: "Daniel K.", s: "Logistics", a: "£85,000" },
  { q: "They found us a government-backed loan we didn't even know existed.", n: "Priya S.", s: "Healthcare", a: "£120,000" },
  { q: "One form, one call, done. Wish I'd found them sooner.", n: "Tom H.", s: "Construction", a: "£60,000" },
  { q: "No spam, no pressure — just a clear recommendation and fast approval.", n: "Rachel W.", s: "Hospitality", a: "£200,000" },
  { q: "Turned down by our bank. Growth Funds matched us in 24 hours.", n: "Chris B.", s: "Manufacturing", a: "£150,000" },
  { q: "Soft search only — exactly as promised. Score untouched.", n: "Aisha M.", s: "E-commerce", a: "£45,000" },
];

export const Testimonials = () => (
  <Section className="pb-24 sm:pb-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <motion.h2 variants={fadeUp} className="font-display font-extrabold text-4xl sm:text-5xl tracking-tight mb-14 max-w-2xl">
        Real results, real fast.
      </motion.h2>
      <div className="grid md:grid-cols-3 gap-5">
        {TESTIMONIALS.map((t, i) => (
          <motion.div key={t.n} variants={fadeUp} custom={i % 3} className="rounded-2xl bg-white border border-[#E5E5E0] p-7 flex flex-col">
            <p className="font-display font-bold text-xl tracking-tight leading-snug mb-6">"{t.q}"</p>
            <div className="mt-auto flex items-center justify-between">
              <div>
                <p className="font-semibold text-sm">{t.n}</p>
                <p className="text-xs text-[#052F24]/50">{t.s}</p>
              </div>
              <span className="font-display font-extrabold text-lg text-[#052F24]">{t.a}</span>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </Section>
);
